import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
import { Reveal } from "../ui/reveal";
/** A centered, oversized statement with a subtle scroll-linked drift. */
export const Callout = React.forwardRef(({ children, className, ...props }, forwardedRef) => {
    const sectionRef = React.useRef(null);
    const driftRef = React.useRef(null);
    const setSectionRef = React.useCallback((element) => {
        sectionRef.current = element;
        if (typeof forwardedRef === "function") {
            forwardedRef(element);
        }
        else if (forwardedRef) {
            forwardedRef.current = element;
        }
    }, [forwardedRef]);
    React.useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            return;
        }
        const section = sectionRef.current;
        const drift = driftRef.current;
        if (!section || !drift)
            return;
        let frame = 0;
        const update = () => {
            frame = 0;
            const rect = section.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const offCenter = rect.top + rect.height / 2 - viewportHeight / 2;
            if (Math.abs(offCenter) > viewportHeight * 1.5)
                return;
            const speed = window.matchMedia("(max-width: 900px)").matches
                ? 0.01
                : 0.03;
            drift.style.transform = `translate3d(0, ${(offCenter * speed).toFixed(1)}px, 0)`;
        };
        const requestUpdate = () => {
            if (!frame)
                frame = requestAnimationFrame(update);
        };
        update();
        window.addEventListener("scroll", requestUpdate, { passive: true });
        window.addEventListener("resize", requestUpdate);
        return () => {
            cancelAnimationFrame(frame);
            window.removeEventListener("scroll", requestUpdate);
            window.removeEventListener("resize", requestUpdate);
        };
    }, []);
    return (_jsx("section", { ref: setSectionRef, className: cn("flex min-h-96 items-start justify-center px-[clamp(24px,10.694vw,154px)] py-36 text-center max-[900px]:min-h-[560px] max-[900px]:items-center max-[900px]:px-m-gutter max-[900px]:py-[88px]", className), "data-callout": true, ...props, children: _jsx("div", { ref: driftRef, className: "will-change-transform motion-reduce:transform-none", children: _jsx(Reveal, { children: _jsx("p", { className: "max-w-[1054px] text-balance font-display text-[clamp(56px,8.333vw,120px)] font-light leading-none tracking-[-2.4px] text-brand-blue max-[900px]:text-[clamp(48px,15vw,68px)] max-[900px]:tracking-[-1.2px]", children: children }) }) }) }));
});
Callout.displayName = "Callout";
//# sourceMappingURL=callout.js.map